import { ActionReducerMapBuilder, createAsyncThunk } from '@reduxjs/toolkit'
import Container from 'typedi'
import i18n from 'i18next'

import { ApplicationState } from '@/state/root.models'
import { RestApiService } from '@/services'
import {
  setSnackbarAction,
  setLoadingFullAction,
} from '@/state/ui/global/slices/index.slices'

import { removeEmptyProp } from '@/utils'
import { BONUS_PROGRAMS } from './api.routes'
import ActionTypes from '../constants'

import { DeleteBonusPayload, DeleteResponse, BonusEngineState } from '../models'
import { getAllBonusesThunk } from './get-all.thunk'

const restApiService: RestApiService = Container.get(RestApiService)

export const deleteBonusEngineThunk = createAsyncThunk(
  ActionTypes.DELETE_BONUS_ENGINE,
  async (payload: DeleteBonusPayload, thunkAPI) => {
    try {
      restApiService.requestParams = {
        method: 'DELETE',
        endpoint: BONUS_PROGRAMS.DELETE_BONUS,
        body: { id: payload._id },
      }

      const { auth, bonusEngine } = thunkAPI.getState() as ApplicationState

      thunkAPI.dispatch(setLoadingFullAction(true))

      const response: DeleteResponse = await restApiService.sendData(
        auth.brand.siteId.toString(),
        auth.token,
      )

      thunkAPI.dispatch(setLoadingFullAction(false))

      let message = i18n.t('messages.successfully', {
        item: `${i18n.t('pages.bonusProgram')} ${payload._id}`,
        what: i18n.t('labels.deleted'),
      })

      if (response.status !== undefined && response.status !== 200) {
        message = i18n.t('messages.errorOccurred')
      } else {
        thunkAPI.dispatch(
          getAllBonusesThunk(removeEmptyProp(bonusEngine.filters)),
        )
      }

      thunkAPI.dispatch(
        setSnackbarAction({
          message,
          open: true,
          variant:
            response.status && response.status !== 200 ? 'error' : 'success',
        }),
      )

      return response
    } catch (error) {
      thunkAPI.dispatch(setLoadingFullAction(false))
      throw error
    }
  },
)

const deleteBonusEngineExtraReducer = (
  builder: ActionReducerMapBuilder<BonusEngineState>,
) => {
  builder.addCase(deleteBonusEngineThunk.pending, (state) => {
    state.isLoading = true
  })
  builder.addCase(deleteBonusEngineThunk.fulfilled, (state, { payload }) => {
    state.isLoading = false
  })
}

export default deleteBonusEngineExtraReducer
